import { BookingModel, BusinessConfig, BusinessTerminology, BusinessUiFlags } from '../types';

type ResolvedUiFlags = Required<BusinessUiFlags>;
type ResolvedTerminology = Required<BusinessTerminology>;

export type ResolvedBookingUxConfig = {
  bookingModel: BookingModel;
  uiFlags: ResolvedUiFlags;
  terminology: ResolvedTerminology;
};

const DEFAULT_UI_FLAGS: ResolvedUiFlags = {
  showHomepageTeamSection: true,
  showHomepageReviewsSection: true,
  showHomepageGallerySection: true,
  showHomepageAboutSection: true,
  showEmployeeBio: true,
  showEmployeeSocials: true,
  showEmployeeProfilePhoto: true,
  showEmployeePickerInBooking: true,
};

const DEFAULT_TERMINOLOGY: ResolvedTerminology = {
  resourceSingular: 'Employee',
  resourcePlural: 'Employees',
  anyAvailableLabel: 'Any Available',
  selectResourceLabel: 'Select employee',
};

export const resolveBookingUxConfig = (config?: BusinessConfig | null): ResolvedBookingUxConfig => {
  const preferences = config?.preferences;
  const terminology = preferences?.terminology;

  const resolveTerm = (
    value: string | undefined,
    fallback: string
  ): string => (typeof value === 'string' && value.trim().length > 0 ? value.trim() : fallback);

  return {
    bookingModel: preferences?.bookingModel ?? 'staff',
    uiFlags: {
      ...DEFAULT_UI_FLAGS,
      ...(preferences?.uiFlags ?? {}),
      showEmployeeBio: preferences?.uiFlags?.showEmployeeBio ?? true,
      showEmployeeSocials: preferences?.uiFlags?.showEmployeeSocials ?? true,
      showEmployeeProfilePhoto: preferences?.uiFlags?.showEmployeeProfilePhoto ?? true,
    },
    terminology: {
      resourceSingular: resolveTerm(terminology?.resourceSingular, DEFAULT_TERMINOLOGY.resourceSingular),
      resourcePlural: resolveTerm(terminology?.resourcePlural, DEFAULT_TERMINOLOGY.resourcePlural),
      anyAvailableLabel: resolveTerm(terminology?.anyAvailableLabel, DEFAULT_TERMINOLOGY.anyAvailableLabel),
      selectResourceLabel: resolveTerm(terminology?.selectResourceLabel, DEFAULT_TERMINOLOGY.selectResourceLabel),
    },
  };
};
